module.exports = __webpack_public_path__ + "040630d191fde7c6cf2cdcc11769443f.png";